import { Col, DatePicker, Input, Row } from "antd";
import AdminModal from "./AdminModal";
import dayjs from 'dayjs'

const AdministrationModal = (props) => {
    return (
        <>
            <AdminModal
                {...props}
                title={(<>
                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 30, left: 50 }} >{props.title}</Col>
                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 60, left: 30 }} >行政人員</Col>
                </>)}
                uploads
            >
                <Row gutter={[8, 8]} align={'middle'}>
                <Col span={6}>姓名</Col>
                    <Col span={18}>
                    <Input style={{ width: 300 }} placeholder={'請輸入行政人員姓名(必填)'} type='text' value={props.editcard.name} name="name" onChange={e => props.setEditCard(pre => ({ ...pre, name: e.target.value }))} />
                    </Col>
                    <Col span={6}>任教系所(單位)</Col>
                    <Col span={18}>
                    <Input style={{ width: 300 }} placeholder={'請輸入行政人員服務單位職稱（必填)'} type='text' value={props.editcard.school_u_work} name="school_u_work" onChange={e => props.setEditCard(pre => ({ ...pre, school_u_work: e.target.value }))} />
                    </Col>
                    <Col span={6}>聯絡電話</Col>
                    <Col span={18}>
                    <Input style={{ width: 300 }} placeholder={'請輸入行政人員電話(必填)'} type='text' value={props.editcard.position} name="position" onChange={e => props.setEditCard(pre => ({ ...pre, position: e.target.value }))} />
                    </Col>
                    <Col span={6}>E-mail</Col>
                    <Col span={18}>
                        <Input placeholder={'請輸入行政人員電子信箱(必填)'} type='email' value={props.editcard && props.editcard.email} name="email" onChange={e => props.setEditCard(pre => ({ ...pre, email: e.target.value }))} />
                    </Col>
                    <Col span={6}>手機</Col>
                    <Col span={18}>
                    <Input style={{ width: 300 }} placeholder={'請輸入行政人員手機'} type='text' value={props.editcard.position_work} name="position_work" onChange={e => props.setEditCard(pre => ({ ...pre, position_work: e.target.value }))} />
                    </Col>
                    <Col span={6}>備註說明</Col>
                    <Col span={18}>
                        <Input.TextArea rows={4} type='text' value={props.editcard.note} name="note" placeholder="請輸入行政人員介紹或個人名言或備註" onChange={e => props.setEditCard(pre => ({ ...pre, note: e.target.value }))} />
                    </Col>
                    {/* <Col span={6}>行政人員姓名</Col>
                    <Col span={18}>
                        <Input placeholder={'請輸入行政人員名稱'} type='text' value={props.editcard.name} name="name" onChange={e => props.setEditCard(pre => ({ ...pre, name: e.target.value }))} />
                    </Col>
                    {props.edit ? <>
                        <Col span={6}>行政人員編號</Col>
                        <Col span={18}>
                            <label>{props.editcard['serial_name']}</label>
                        </Col>
                    </> : null}

                    <Col span={6}>行政人員職位</Col>
                    <Col span={18}>
                        <Input placeholder={'請輸入行政人員職位'} type='text' value={props.editcard.position} name="position" onChange={e => props.setEditCard(pre => ({ ...pre, position: e.target.value }))} />
                    </Col>
                    <Col span={6}>行政人員職務</Col>
                    <Col span={18}>
                        <Input placeholder={'請輸入行政人員職務'} type='text' value={props.editcard.position_work} name="position_work" onChange={e => props.setEditCard(pre => ({ ...pre, position_work: e.target.value }))} />
                    </Col>
                    <Col span={6}>行政人員電話</Col>

                    <Col span={18}>
                        <Input placeholder={'請輸入行政人員電話'} type='text' value={props.editcard.phone} name="phone" onChange={e => props.setEditCard(pre => ({ ...pre, phone: e.target.value }))} />
                    </Col>
                    <Col span={8}>行政人員電子信箱</Col>
                    <Col span={16}>
                        <Input placeholder={'請輸入行政人員電子信箱'} type='email' value={props.editcard.email} name="email" onChange={e => props.setEditCard(pre => ({ ...pre, email: e.target.value }))} />
                    </Col>
                    <Col span={6}>行政人員地址</Col>

                    <Col span={18}>
                        <Input placeholder={'請輸入行政人員地址'} type='text' value={props.editcard.address} name="address" onChange={e => props.setEditCard(pre => ({ ...pre, address: e.target.value }))} />
                    </Col>
                    <Col span={9}>行政人員入職時間</Col>
                    <Col span={15}>
                        <DatePicker style={{ width: '100%' }}
                            value={props.editcard.employment_time_start != '' && props.editcard.employment_time_start != null ? dayjs(props.editcard.employment_time_start, 'YYYY-MM-DD') : null}
                            format={'YYYY-MM-DD'}
                            onChange={(value, dateString) => props.setEditCard(preState => {
                                return (
                                    {
                                        ...preState,
                                        'employment_time_start': dateString,
                                    }
                                )
                            })}
                        />
                    </Col>
                    <Col span={9}>行政人員離職時間</Col>
                    <Col span={15}>
                        <DatePicker style={{ width: '100%' }}
                            format={'YYYY-MM-DD'}
                            value={props.editcard.employment_time_end != '' && props.editcard.employment_time_end != null ? dayjs(props.editcard.employment_time_end, 'YYYY-MM-DD') : null}
                            onChange={(value, dateString) => props.setEditCard(preState => {
                                return (
                                    {
                                        ...preState,
                                        'employment_time_end': dateString,
                                    }
                                )
                            })}
                        />
                    </Col> */}
                    {/* <Col span={6}>說明</Col>
                    <Col span={18}>
                        <Input.TextArea rows={4} type='text' value={props.editcard.note} name="note" placeholder="請輸入行政人員介紹或個人名言" onChange={e => props.setEditCard(pre => ({ ...pre, note: e.target.value }))} />
                    </Col> */}
                </Row>

            </AdminModal>
        </>
    )

}
export default AdministrationModal;
// import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, Space, Radio, Card, Input, Select, Checkbox, DatePicker, message } from 'antd';
// import React, { useEffect, useState, useRef } from 'react';
// import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
// import { ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
// import axios from 'axios';
// import moment from "moment";
// import dayjs from 'dayjs';
// import PreviewImgModal from './PreviewImgModal';
// const { Title, Paragraph, Text, Link } = Typography;
// const { confirm } = Modal;
// const { TextArea } = Input;
// const AdministrationModal = (props) => {
//     const [check, setCheck] = useState(false);
//     const [blog_check, set_blog_check] = useState(false);
//     const [administration_id, set_administration_id] = useState(null);
//     const [modal_img, set_modal_img] = useState(false);
//     const [img, setImg] = useState('');
//     const [grade_option, set_grade_option] = useState([])
//     const [fileList, setFileList] = useState([]);
//     const [messageApi, contextHolder] = message.useMessage();
//     useEffect(() => {
//         setCheck(false);
//         set_blog_check(false);
//         if (JSON.stringify(props.editcard) != '{}') {
//             set_administration_id(props.editcard.administration_id);
//         } else {
//             props.setEditCard({ file_id: [], file_url: [] });
//             setFileList([]);
//             set_administration_id('');
//         }
//         if (administration_id != props.editcard.administration_id && JSON.stringify(props.editcard) != '{}') {
//             setFileList([]);
//         }
//     }, [props.editcard])
//     const remove = (e) => {
//         setFileList(prev => prev.filter(filter_item=>filter_item.uid!==e.uid));
//     }
//     useEffect(() => {
//         // console.log(props.editcard)
//         setFileList([]);
//         const data_tmp = [];
//         props.editcard.file_id && props.editcard.file_id.forEach((element, i) => {
//             if (props.editcard.file_url != undefined) {
//                 data_tmp.push({ uid: element, url: props.editcard.file_url[i] })
//             }
//         })
//         setFileList(data_tmp)

//     }, [props.editcard['file_url']])
//     const handleUpload = (e) => {
//         e = e.file;
//         let form_data = new FormData();
//         form_data.append('inputFile', e);
//         axios
//             .post(`/cramSchool/api/file`, form_data,
//                 {
//                     headers: {
//                         'Content-Type': 'multipart/form-data'
//                     }
//                 })
//             .then((response) => {
//                 let file_id = parseInt(response.data.file_id);
//                 // console.log(file_id);
//                 // get_picture(file_id);
//                 const dataurl = URL.createObjectURL(e);
//                 if (JSON.stringify(props.editcard) == '{}' || props.editcard.file_id == undefined) {
//                     props.setEditCard(
//                         pre => {
//                             return (
//                                 {
//                                     file_id: [file_id],
//                                     file_url: [dataurl]
//                                 }
//                             )
//                         }
//                     )
//                 } else {
//                     props.setEditCard(
//                         prev => {
//                             if (props.editcard.file_id.length == 0) {
//                                 return (
//                                     {
//                                         ...prev,
//                                         file_id: [file_id],
//                                         file_url: [dataurl]
//                                     }
//                                 )
//                             } else {
//                                 return (
//                                     {
//                                         ...prev,
//                                         file_id: [...prev.file_id, file_id],
//                                         file_url: [...prev.file_url || [], dataurl]
//                                     }
//                                 )
//                             }
//                         }
//                     );
//                 }
//             })
//     }
//     const showConfirm = (e) => {
//         confirm({
//             title: '確認要刪除此張圖片嗎？',
//             icon: <ExclamationCircleFilled />,
//             onOk() {
//                 remove(e);
//             },
//         });
//     };
//     const handlePreview = (e) => {
//         setImg(e.url);
//         set_modal_img(true);
//     }
//     return (
//         <>
//             {contextHolder}
//             <PreviewImgModal
//                 modal_img={modal_img}
//                 set_modal_img={set_modal_img}
//                 img={img}
//             ></PreviewImgModal>
//             <Modal
//                 // width={'auto'}
//                 style={{ pointerEvents: 'auto' }}
//                 open={props.open}
//                 onOk={props.handleOk}
//                 bodyStyle={{ backgroundColor: props.edit ? '#faf6f5' : '##FCF5F6' }}
//                 width={450}
//                 footer={false}
//                 data={props.data}
//                 title={props.title}
//                 className="modalStyle2"
//                 wrapClassName={"modalStyle2"}
//                 modalRender={(e) => <>
//                     <div style={{ backgroundColor: props.edit ? '#faf6f5' : '#FCF5F6', padding: '20px', borderTop: `solid #${props.color} 5px `, position: 'relative', height: '80vh' }}>
//                         <Row gutter={[10, 10]} justify='center' style={{ minHeight: '65vh', maxHeight: '65vh', overflowY: 'scroll' }}>
//                             <Col span={24}>
//                                 <Col span={24}>
//                                     <Row justify="space-between" align={'bottom'}>
//                                         {props.edit ?
//                                             <>
//                                                 <img style={{ position: 'relative' }} width="35%" height="35%" src='/cram_school/edit.png'></img>
//                                             </> :
//                                             <>
//                                                 <img style={{ position: 'relative' }} width="35%" height="35%" src='/cram_school/add.png'></img>
//                                             </>}
//                                         <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 30, left: 50 }} >{props.title}</Col>
//                                         <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 60, left: 30 }} >行政人員</Col>
//                                     </Row>
//                                 </Col>
//                                 <Col span={24}>
//                                     <Row gutter={[8, 8]} align={'middle'}>
//                                         <Col span={6}>行政人員名稱</Col>
//                                         <Col span={18}>
//                                             <Input placeholder={'請輸入行政人員名稱'} type='text' value={props.editcard.name} name="name" onChange={e => props.setEditCard(pre => ({ ...pre, name: e.target.value }))} />
//                                         </Col>
//                                         <Col span={6}>行政人員職位</Col>

//                                         <Col span={18}>
//                                             <Input placeholder={'請輸入行政人員職位'} type='text' value={props.editcard.position} name="position" onChange={e => props.setEditCard(pre => ({ ...pre, position: e.target.value }))} />
//                                         </Col>
//                                         <Col span={6}>行政人員電話</Col>

//                                         <Col span={18}>
//                                             <Input placeholder={'請輸入行政人員電話'} type='text' value={props.editcard.phone} name="phone" onChange={e => props.setEditCard(pre => ({ ...pre, phone: e.target.value }))} />
//                                         </Col>
//                                         <Col span={8}>行政人員電子信箱</Col>
//                                         <Col span={16}>
//                                             <Input placeholder={'請輸入行政人員電子信箱'} type='email' value={props.editcard.email} name="email" onChange={e => props.setEditCard(pre => ({ ...pre, email: e.target.value }))} />
//                                         </Col>
//                                         <Col span={6}>行政人員地址</Col>

//                                         <Col span={18}>
//                                             <Input placeholder={'請輸入行政人員地址'} type='text' value={props.editcard.address} name="address" onChange={e => props.setEditCard(pre => ({ ...pre, address: e.target.value }))} />
//                                         </Col>
//                                         <Col span={9}>行政人員入職時間</Col>
//                                         <Col span={15}>
//                                             <DatePicker style={{ width: '100%' }}
//                                                 value={props.editcard.employment_time_start != null ? dayjs(props.editcard.employment_time_start, 'YYYY-MM-DD') : ''}
//                                                 format={'YYYY-MM-DD'}
//                                                 onChange={(value, dateString) => props.setEditCard(preState => {
//                                                     return (
//                                                         {
//                                                             ...preState,
//                                                             'employment_time_start': dateString,
//                                                         }
//                                                     )
//                                                 })}
//                                             />
//                                         </Col>
//                                         <Col span={9}>行政人員離職時間</Col>
//                                         <Col span={15}>
//                                             <DatePicker style={{ width: '100%' }}
//                                                 format={'YYYY-MM-DD'}
//                                                 value={props.editcard.employment_time_end != null ? dayjs(props.editcard.employment_time_end, 'YYYY-MM-DD') : ''}
//                                                 onChange={(value, dateString) => props.setEditCard(preState => {
//                                                     return (
//                                                         {
//                                                             ...preState,
//                                                             'employment_time_end': dateString,
//                                                         }
//                                                     )
//                                                 })}
//                                             />
//                                         </Col>
//                                         <Col span={6}>上傳圖片</Col>
//                                         <Col span={18}>
//                                             <Upload
//                                                 accept="image/png,image/jpeg"
//                                                 customRequest={handleUpload}
//                                                 listType="picture-card"
//                                                 fileList={fileList}
//                                                 onPreview={handlePreview}
//                                                 onRemove={e => showConfirm(e)}
//                                                 // onChange={handleUpload} 
//                                                 beforeUpload={false}
//                                             >
//                                                 <div>
//                                                     <PlusOutlined />
//                                                     <div
//                                                         style={{
//                                                             marginTop: 8,
//                                                         }}
//                                                     >
//                                                         上傳圖片
//                                                     </div>
//                                                 </div>
//                                             </Upload>
//                                             {/* {props.edit ? null :
//                                             <>
//                                                 <Checkbox >排程發佈</Checkbox>
//                                             </>} */}
//                                         </Col>
//                                         <Col span={6}></Col>
//                                         <Col span={18}>＊請注意圖片大小，限制在2MB以內</Col>
//                                         <Col span={18}>
//                                             <TextArea rows={4} type='text' value={props.editcard.note} name="note" placeholder="請輸入行政人員介紹或個人名言" onChange={e => props.setEditCard(pre => ({ ...pre, note: e.target.value }))} />
//                                         </Col>
//                                     </Row>
//                                 </Col>
//                             </Col>
//                             <Col span={20} style={{ position: 'absolute', bottom: '3vh' }}>
//                                 <Row gutter={[10, 10]} justify={"center"}>
//                                     <Col>
//                                         <Button size='large' style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => props.setOpen(false)} block>取消</Button>
//                                     </Col>
//                                     <Col >
//                                         <Button
//                                             onClick={e => { props.edit ? props.handleEdit() : props.handleSubmit() }}
//                                             size='large' style={{ background: `#${props.color}`, color: '#ffffff' }} block>{props.edit ? '修改' : '送出'}</Button>
//                                     </Col>
//                                 </Row>
//                             </Col>
//                         </Row>
//                     </div >
//                 </>}
//                 centered
//             >
//             </Modal >
//         </>
//     )

// }
// export default AdministrationModal;